import PropTypes from 'prop-types';
import React from 'react';
import { Consumer as PageConsumer } from '../../../contexts/PageContext';
import CommonCardShell from '../../Layout/CommonCardShell/CommonCardShell';
import ListSection from '../../Layout/ListSection/ListSection';
import { LOGIN_LAYOUT } from '../../Login/LoginLayoutComponent/Layouts/LogInLayout/constants';
import { buildImagePath } from '../User/UserDisplay/UserImage/UserImage';
import './CreateContentWidgetV2.scss';

class CreatContentWidgetV2 extends React.PureComponent {
    render() {
        const imgPath = buildImagePath(
            '/v1555536356/SVGs/Create_Girl.svg',
            'medium'
        );
        return (
            <div className="component-Content-CreateContentWidgetV2-CreatContentWidgetV2">
                <PageConsumer>
                    {(context) =>
                        context.wrapAuth(
                            'CreateContent',
                            <CommonCardShell>
                                <div
                                    role="button"
                                    tabIndex="0"
                                    className="cta-wrapper"
                                    onKeyDown={() =>
                                        context.isLoggedIn()
                                            ? context.modalTrigger(
                                                  'CreateContentPopup',
                                                  {
                                                      defaultPostLocation: this
                                                          .props
                                                          .defaultPostLocation,
                                                  }
                                              )
                                            : null
                                    }
                                    onClick={() =>
                                        context.isLoggedIn()
                                            ? context.modalTrigger(
                                                  'CreateContentPopup',
                                                  {
                                                      defaultPostLocation: this
                                                          .props
                                                          .defaultPostLocation,
                                                  }
                                              )
                                            : null
                                    }
                                >
                                    <ListSection title="Start a Post">
                                        <img alt="" src={imgPath} />
                                        <div
                                            className="text-placeholder"
                                            data-qa="Share your thoughts"
                                        >
                                            <span>
                                                Share your thoughts (even
                                                anonymously)...
                                            </span>
                                        </div>
                                    </ListSection>
                                </div>
                            </CommonCardShell>,
                            { login_trigger: 'create-content' },
                            null,
                            LOGIN_LAYOUT
                        )
                    }
                </PageConsumer>
            </div>
        );
    }
}

CreatContentWidgetV2.propTypes = {
    /**
     * object of topic page user is currently on
     */
    // eslint-disable-next-line react/forbid-prop-types
    defaultPostLocation: PropTypes.object,
};

CreatContentWidgetV2.defaultProps = {
    /**
     * topic set to null
     */
    defaultPostLocation: null,
};

export default CreatContentWidgetV2;
